try {
  function convertTTextToSup(className) {
    var elements = document.querySelectorAll(className);
    var regex = /T (.*?) T/g;
    elements.forEach(function (element) {
      element.innerHTML = element.innerHTML.replace(
        regex,
        function (match, p1) {
          var supElement = document.createElement("sup");
          supElement.textContent = p1;
          return supElement.outerHTML;
        }
      );
    });
  }
  var classArray = [
    ".collectionpage-colum-section",
    ".custom_faq_accordian",
    ".ed-image-with-text",
  ];
  classArray.forEach(function (className) {
    convertTTextToSup(className);
  });
} catch (e) {}

try {
  $(function () {
    function updateSubsPrice(disEl, qty) {
      var cp = $(".template_product product-meta .price.price--large").attr(
        "data-ed-price"
      );
      if (cp) {
        var disP = parseFloat(disEl);
        if (disP) {
          var saveAmount = (disP / 100) * cp;
          saveAmount = saveAmount / 100;
          saveAmount = saveAmount * qty;
          saveAmount = saveAmount.toFixed(2) + " €";
          saveAmount = saveAmount.replace(".", ",");
          var rowcp = cp;
          cp = cp / 100;
          cp = cp * qty;
          cp = cp.toFixed(2) + " €";
          cp = cp.replace(".", ",");

          $(".main_product_container .product__info .price-list").prepend(
            `<span class="price price--compare ssp" data-ed-compare-price="${rowcp}">${cp}</span>`
          );
          $(".product__info .product-meta__label-list").append(
            `<span class="label label--highlight ssp"><span class="ed-save-amount">-${saveAmount}</span></span>`
          );

          $(".product-sticky-form__form .price-list").prepend(
            `<span class="price price--compare ssp" data-ed-compare-price="${rowcp}">${cp}</span>`
          );
          $(".product-sticky-form__form .product-meta__label-list").append(
            `<span class="label label--highlight ssp"><span class="ed-save-amount">-${saveAmount}</span></span>`
          );
        }

        let p = document
          .querySelector(".template_product product-meta .price.price--large")
          .getAttribute("data-ed-price");
        var np;
        if (disEl) {
          var amountToSubtract = (disEl / 100) * p;
          np = p - amountToSubtract;
          np = np * qty;
        } else {
          np = p * qty;
        }
        np = np / 100;
        document.querySelector(
          ".template_product product-meta .price.price--large"
        ).textContent = np.toFixed(2) + "€";

        document.querySelector(
          ".product-sticky-form__form .price.price--large"
        ).textContent = np.toFixed(2) + "€";
      }
      if (!$(".template_product product-meta .price.price--compare").length) {
        document
          .querySelector(".template_product product-meta .price.price--large")
          .classList.remove("price--highlight");

        document
          .querySelector(".product-sticky-form__form .price.price--large")
          .classList.remove("price--highlight");
      } else {
        document
          .querySelector(".template_product product-meta .price.price--large")
          .classList.add("price--highlight");
        document
          .querySelector(".product-sticky-form__form .price.price--large")
          .classList.add("price--highlight");
      }
    }

    $(".quantity-item").click(function (e) {
      let qty = Number($(this).attr("data-qty"));
      if (qty == 1) {
        var elements = document.querySelectorAll(".ssp");
        var elementsArray = Array.from(elements);
        elementsArray.forEach(function (element) {
          element.parentNode.removeChild(element);
        });

        if (!$(".template_product product-meta .price.price--compare").length) {
          document
            .querySelector(".template_product product-meta .price.price--large")
            .classList.remove("price--highlight");
          document
            .querySelector(".product-sticky-form__form .price.price--large")
            .classList.remove("price--highlight");
        }
      }

      let db = Number($(this).attr("data-discount-value"));

      var up = $(
        ".template_product product-meta .custom-unit-price-custom-sub"
      ).attr("data-unit-price");
      var upm = $(
        ".template_product product-meta .custom-unit-price-custom-sub"
      ).attr("data-unit-measurement");

      var nup = ((up / 100) * (100 - db)) / 100;
      document.querySelector(
        ".template_product product-meta .custom-unit-price-custom-sub"
      ).textContent = nup.toFixed(2) + "€/" + upm;

      let p = document
        .querySelector(".template_product product-meta .price.price--large")
        .getAttribute("data-ed-price");

      if (!$(".template_product product-meta .price.price--compare").length) {
        updateSubsPrice(db, qty);
      } else {
        let cp = document
          .querySelector(".template_product product-meta .price.price--compare")
          .getAttribute("data-ed-compare-price");

        var np;
        if (db) {
          var amountToSubtract = (db / 100) * p;
          np = p - amountToSubtract;
          np = np * qty;
        } else {
          np = p * qty;
        }
        var ncp = cp * qty;
        var ndp = ncp - np;

        np = np / 100;
        ncp = ncp / 100;
        ndp = ndp / 100;

        document.querySelector(
          ".template_product product-meta .price.price--compare"
        ).textContent = ncp.toFixed(2) + "€";
        document.querySelector(
          ".template_product product-meta .price.price--large"
        ).textContent = np.toFixed(2) + "€";
        document.querySelector(
          ".template_product product-meta .ed-save-amount"
        ).textContent = "-" + ndp.toFixed(2) + "€";

        document.querySelector(
          ".template_product .product-sticky-form__form .price.price--compare"
        ).textContent = ncp.toFixed(2) + "€";
        document.querySelector(
          ".template_product .product-sticky-form__form .price.price--large"
        ).textContent = np.toFixed(2) + "€";
        document.querySelector(
          ".template_product .product-sticky-form__form .ed-save-amount"
        ).textContent = "-" + ndp.toFixed(2) + "€";
      }
    });
  });
} catch (e) {
  console.log(e);
}
try {
  const qtds = document.querySelectorAll(".ed-quantity-discounts");
  qtds.forEach((qtd) => {
    const qtdi = qtd.querySelectorAll(".quantity-item");
    qtdi.forEach((item, index) => {
      item.addEventListener("click", () => {
        const clickedIndex = index;
        const oqtd = Array.from(qtds).find((qd) => qd !== qtd);
        const oqtdi = oqtd.querySelectorAll(".quantity-item");
        oqtdi[clickedIndex].click();
      });
    });
  });
} catch (e) {}
